import { GetArtifactSidebarQueryQuery, GoalScope } from "types/graphql-schema";

import ArtifactActivities from "@apps/artifact-sidebar/components/artifact-activities";
import DiscussionNotes from "@apps/artifact-sidebar/components/discussion-notes";
import GoalGrowthConnectionList from "@apps/artifact-sidebar/components/goal-growth-connection-list";
import GoalKeyResultList from "@apps/artifact-sidebar/components/goal-key-result-list";
import ArtifactSidebarHeader from "@apps/artifact-sidebar/components/header";
import {
  GoalAlignmentSection,
  GoalParametersList,
} from "@apps/artifact-sidebar/goal-section";
import useLabel from "@apps/use-label/use-label";

export type GoalArtifact = Extract<
  GetArtifactSidebarQueryQuery["artifact"],
  { __typename: "GoalArtifactNode" }
>;

// The single goal experience — title, description, details, key results,
// alignment and comments — shared by the full page (/goal/:id) and the goal
// drawer, so changes to one are always reflected in the other.
const GoalContent = ({
  goal,
  meetingId,
  meetingGroupId,
}: {
  goal: GoalArtifact;
  meetingId?: number;
  meetingGroupId?: number;
}) => {
  const label = useLabel();

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-2">
        <ArtifactSidebarHeader artifact={goal} variant="page" />

        {/* Description sits directly under the title, styled as plain
            left-aligned page text with no toolbar. */}
        <DiscussionNotes
          artifact={goal}
          showFixedMenu={false}
          showPlusButton={false}
          className="text-base min-h-16 py-1 !pl-0 !pr-0"
        />
      </div>

      <section className="flex flex-col gap-2">
        <div className="tf-header-base-dark">
          {label("goal", { capitalize: true })} Details
        </div>
        <GoalParametersList artifact={goal} />
      </section>

      <GoalKeyResultList goalArtifact={goal} variant="page" />

      {goal.scope === GoalScope.Development && (
        <GoalGrowthConnectionList goalArtifact={goal} variant="page" />
      )}

      <GoalAlignmentSection artifact={goal} />

      <section className="flex flex-col gap-4">
        <div className="tf-header-base-dark">Comments</div>
        <ArtifactActivities
          artifact={goal}
          meetingId={meetingId}
          meetingGroupId={meetingGroupId}
        />
      </section>
    </div>
  );
};

export default GoalContent;
